import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { get, elementRulesStateToProps } from 'ctm-util-functions';
import { SimpleFlexbox, HelpIndicator, BackButton } from 'ctm-components';
import styles from './custom_field_row.css';
import { ContentFieldRow } from './content_field_row';

/**
 * Returns Tooltip
 * @param {Object} props - the props to render the tooltips
 * @param {Object} props.helpText - The tooltip object with content and title
 * @param {String} props.identifier - The components identifier
 * @returns {Node|null} - Returns the tooltip component
 */
const getToolTip = ({ helpText, identifier }) => {
    if (!helpText) return null;
    const helpTextProps = {
        schema: { identifier: `${identifier}_tooltip` },
        contentProps: { ...helpText }
    };
    return (
        <SimpleFlexbox className={styles.tooltip}>
            <HelpIndicator {...helpTextProps} placement="left" />
        </SimpleFlexbox>
    );
};

/**
 * Return Back Button
 * @param {Boolean} hideBackButton - show or hide back Button
 * @returns {Node} - Returns the BackButton component
*/
const getBackButton = (hideBackButton) => {
    const contentProps = { label: 'Back', iconPosition: 'before', icon: 'ctm_angle_left' };
    const elementProps = { tagName: 'a', href: 'javascript:;' };
    return !hideBackButton ? (
        <BackButton
            className={styles.backButton}
            contentProps={contentProps}
            elementProps={elementProps} />
    ) : null;
};

/**
 * A TextTemplate wrapper with styles to fit in a fieldRow
 * @param {Object} props - properties to render the component
 * @param {Object} props.schema - element's schema
 * @param {Object} rules - The resolved rules for the element
 * @returns {Node} - A TextTemplate component with simples scripting styles
 */
const _HeaderFieldRow = ({ schema, isVisible }) => {
    if (!isVisible) {
        return null;
    }
    const { identifier, helpText, hideBackButton = false } = schema;
    const contentSchema = { ...schema, tagName: 'h2' };
    return (
        <SimpleFlexbox display="flex">
            {getBackButton(hideBackButton)}
            <ContentFieldRow schema={contentSchema} />
            {getToolTip({ helpText, identifier })}
        </SimpleFlexbox>
    );
};

_HeaderFieldRow.propTypes = {
    schema: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired
};

getToolTip.propTypes = {
    identifier: PropTypes.string,
    helpText: PropTypes.string
};

const mapStateToProps = (state, props) => {
    const _rules = elementRulesStateToProps()(state, props).rules;
    return {
        isVisible: get(_rules, 'visibility.result', true)
    };
};

const HeaderFieldRow = connect(mapStateToProps)(_HeaderFieldRow);

export { _HeaderFieldRow, HeaderFieldRow };
